import React from 'react';
import { Tabs, Tab, Card, Button } from 'react-bootstrap';
import OrgPlaidSettings from './OrgPlaidSettings';
import OrgProjectTeam from './OrgProjectTeam';
import OrgUserManagement from './OrgUserManagement';
import OrgPlaidConnections from './OrgPlaidConnections';

const OrgDashboard = ({ org, onBack, users, fetchOrganizations, addUser, usersLoading }) => {
  return (
    <div className="org-dashboard">
      <div className="mb-4 d-flex align-items-center">
        <Button 
          variant="outline-secondary" 
          size="sm" 
          onClick={onBack}
          className="mr-3 py-1 px-2 border-0"
          style={{ borderRadius: '6px' }}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>
        <div>
          <h1 className="h3 font-weight-bold text-dark mb-0">{org.name} Workspace</h1>
          <p className="text-muted small mb-0">{org.description || 'No organization description.'}</p>
        </div>
      </div>

      <Card className="shadow-sm border-0">
        <Card.Body className="p-0">
          <Tabs 
            defaultActiveKey="projects" 
            id="org-tabs" 
            className="custom-tabs bg-light border-bottom px-3 pt-2"
          >
            <Tab 
              eventKey="projects" 
              title={<span><i className="fas fa-folder mr-2"></i>Projects & Team</span>} 
              className="p-4"
            >
              <OrgProjectTeam org={org} users={users} />
            </Tab>

            <Tab 
              eventKey="members" 
              title={<span><i className="fas fa-users-cog mr-2"></i>Organization Members</span>} 
              className="p-4"
            >
              <OrgUserManagement 
                org={org} 
                users={users} 
                fetchOrganizations={fetchOrganizations} 
                addUser={addUser} 
                usersLoading={usersLoading} 
              />
            </Tab>
            
            <Tab 
              eventKey="plaid-keys" 
              title={<span><i className="fas fa-key mr-2"></i>Plaid API Keys</span>} 
              className="p-4"
            >
              <OrgPlaidSettings org={org} onUpdate={fetchOrganizations} />
            </Tab>

            <Tab 
              eventKey="plaid-connections" 
              title={<span><i className="fas fa-plug mr-2"></i>Bank Links</span>} 
              className="p-4"
            >
              <OrgPlaidConnections org={org} />
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>

      <style dangerouslySetInnerHTML={{ __html: `
        .custom-tabs .nav-link {
          border: none;
          color: #6c757d;
          font-weight: 600;
          font-size: 0.9rem;
          padding: 10px 20px;
          margin-bottom: -1px;
        }
        .custom-tabs .nav-link:hover {
          color: #007bff;
          background: none;
        }
        .custom-tabs .nav-link.active {
          color: #007bff;
          background: none;
          border-bottom: 3px solid #007bff;
        }
        .org-dashboard h1 { font-size: 1.65rem; }
      `}} />
    </div>
  );
};

export default OrgDashboard;
